export const installationsNewClientSalesActionTypes = {
  FETCH_INSTALLATIONS: 'OVID/NEW_CLIENT_SALES/FETCH_INSTALLATIONS'
}

export const fetchInstallationsNewClientSales = payload => ({
  type: installationsNewClientSalesActionTypes.FETCH_INSTALLATIONS,
  payload,
})
